import { render, staticRenderFns } from "./pxjd.vue?vue&type=template&id=f208c0c6&scoped=true"
import script from "./pxjd.vue?vue&type=script&lang=js"
export * from "./pxjd.vue?vue&type=script&lang=js"
import style0 from "../../views/matrix-page/assets/css/rem.css?vue&type=style&index=0&id=f208c0c6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f208c0c6",
  null
  
)

export default component.exports